import { OktaAuth, toRelativeUrl, OktaAuthOptions } from '@okta/okta-auth-js';
import { Authority } from 'drive-ui-packages';
import { oktaVars } from 'adapters/configs';
import { URL_ROUTES } from 'adapters/constants';
import { OktaVariablesNoIAM } from 'adapters/types';
import { AUTHORITIES, ROLES } from 'common/constants';

export const oktaVariablesNoIAM = (isMFE: boolean): OktaVariablesNoIAM => ({
  issuer: oktaVars(isMFE).issuer,
  clientId: oktaVars(isMFE).clientId,
  redirectUri: oktaVars(isMFE).redirectUri,
  authorizeUrl: oktaVars(isMFE).authorizeUrl,
  scopes: oktaVars(isMFE).scopes
});

export const oktaIAMVariables = (isMFE: boolean): OktaAuthOptions => ({
  ...oktaVariablesNoIAM(isMFE),
  tokenUrl: oktaVars(isMFE).tokenUrl
});

export const restoreOriginalUri = (
  _oktaAuth: OktaAuth,
  originalUri: string
): void => {
  const url = toRelativeUrl(
    originalUri || URL_ROUTES.landingPage,
    window.location.origin
  );
  window.location.replace(url);
};

export const getUserRole = (permissions?: Authority[]): string => {
  const authorities = permissions?.map(({ authority }: Authority) => authority);

  const checkAuthorities = (authority: string) =>
    authorities?.includes(authority);

  if (
    checkAuthorities(AUTHORITIES.READ_ACCOUNTS_PAYABLE) ||
    checkAuthorities(AUTHORITIES.READ_DMS_ACCOUNTS_PAYABLE)
  ) {
    if (
      checkAuthorities(AUTHORITIES.AUTHORIZE_AP_PAYMENTS) ||
      checkAuthorities(AUTHORITIES.AUTHORIZE_DMS_AP_PAYMENTS) ||
      checkAuthorities(AUTHORITIES.AUTHORIZE_APCHECK)
    )
      return ROLES.AP_OFFICE_MANAGER;
    return ROLES.AP_CLERK;
  }
  return ROLES.UNAUTHORIZED;
};
